<template>
  <div class="tipo">
    <div class="centro">
      <h1>Consulta por Tipo de Ato Administrativo</h1>
      <BuscaSimplesCards
        titulo="Consultas Rápidas"
        :cards="cardsAtoAdministrativo"
      />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="tiposFormatados"
        :generateUrl="generateUrl"
        titulo="Tipos de Ato"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import IndexAtoAdministrativoApi from "../../services/IndexAtoAdministrativoApi";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import PainelBuscaSimplificada from "../../components/PainelBuscaSimplificada";
import { mixinAtoAdministrativo } from "../../mixins/mixinAtoAdministrativo";
import metaDados from "../../helpers/metaDados";

export default {
  name: "PorTipoAtoAdministrativo",
  metaInfo() {
    return {
      title: "Pesquisa de Ato Administrativo por Tipo de Ato",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Tipo - Decretos e Portarias de nomeação",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Tipo - Decretos e Portarias de nomeação",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa de Índice de Ato Administrativo por Tipo - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Tipo - Decretos e Portarias de nomeação",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa de Índice de Ato Administrativo por Tipo - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinAtoAdministrativo],
  data() {
    return {
      carregando: true,
      erro: false,
      tipos: [],
      filtro: {
        tipo_ato: [],
        ano: null,
      },
    };
  },
  computed: {
    // Parte para formatar os números com separador milhar.
    tiposFormatados() {
      return this.tipos.map((tipo) => {
        return {
          ...tipo,
          quantidade_total: tipo.quantidade_total,
        };
      });
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
  },
  created() {
    this.indexAtoAdministrativo = new IndexAtoAdministrativoApi();

    this.carregarTipos();
  },
  methods: {
    carregarTipos: async function () {
      try {
        if (this.indexAtoAdministrativo.cancelTokens.getTiposAgrupados) {
          this.indexAtoAdministrativo.cancelTokens.getTiposAgrupados.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.tipos = await this.indexAtoAdministrativo.getTiposAgrupados();
        this.carregando = false;
      } catch (err) {
        if (this.indexAtoAdministrativo.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.tipo_ato = dados.id;
      this.filtro.ano = ano;

      this.$router.push({
        name: "PesquisaIndexAtoAdministrativo",
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });
    },
    formatNumber(number) {
      // Método para formatar os números com separador milhar.
      if (number) return number.toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #115810;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}

p {
  text-indent: 1.5rem;
  margin: 1rem 1.5rem 1rem 0.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.03rem;
  strong {
    text-transform: uppercase;
  }
}

.alto-contraste {
  p {
    color: white;
  }
}
</style>
